<template>
  <div v-if="fields.length">
    <action-alert :type="alert.type" :icon="alert.icon" :is-visible="alert.isVisible">{{alert.text}}</action-alert>
    <SavedSearches :years-object="yearsObject" :apply="applyQuery" :remove="removeSavedQuery" ref="savedSearches"></SavedSearches>
    <div class="container-fluid">
      <DiagnosticsPopup v-if="Object.keys(analytics).length && showDiagnostics" class="diagnostics"
                        :class="{'sidebard-toggled': isSidebarToggled}" :toggle-diagnostics="toggleDiagnostics"
                        :data="analytics.errorlog"></DiagnosticsPopup>
      <Breadcrumb :values="{ Home: '/', [searchIsMetricBased ? 'Analytics' : 'Search']: '' }"></Breadcrumb>
      <div class="animated" :class="{fadeIn: triggerFadeIn}">
        <!--        <div v-if="!$route.params.hideDescription" class="d-flex justify-content-start">-->
        <!--          <span class="description-header">{{searchIsMetricBased ? 'I work in CMI and want to run some customized analytics' : 'Find a study/studies, pull up results and/or study materials.'}}</span>-->
        <!--        </div>-->
        <div>
          <SearchFilters :years-object="yearsObject" :fields="fields" :searchData="searchData" :hideTabs="hideTabs"
                         :parseData="searchFunctions.parseDataForSearch" :switchTabs="switchTabs" @setCollapse="val => filtersVisible = val"
                         :saveFilters="saveQuery" :saveMessage="saveMessage" :toggle-diagnostics="toggleDiagnostics" :resetDropdowns="resetDropdownValues"
                         ref="filters" :header="$route.params.header" :toggleSavedSearches="toggleSavedSearches"
                         :showSavedSearches="showSavedSearches" :update-dropdown-values="updateDropdownValues" :collapsed="filtersVisible"></SearchFilters>
        </div>
        <div class="animated fadeIn">
          <div class="col-12 px-0 mb-4" style="margin-top: 39px" v-if="showTabs">
            <SearchTabs :switch-tabs="switchTabs" :is-ready="isReady"
                        :dependencies="dependencies"
                        :collapsed="filtersVisible" :parseData="searchFunctions.parseDataForSearch"
                        :active-tab="activeTab" :ready="ready" :toggle-alert="toggleAlert"
                        @multiple-edit="refreshData"></SearchTabs>
            <div v-if="searchIsMetricBased" class="footnote">
              <span class="footnote-text">All scores and metrics have been harmonized to a common 5 point scale</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'

import Breadcrumb from '../components/shared/Breadcrumb'
import generalActions from '../store/modules/general/actionTypes'
import SavedSearches from '../components/Search/SavedSearches'
import SearchFilters from '../components/Search/SearchFilters'
import studiesActions from '../store/modules/studies/actionTypes'
import studiesGetters from '../store/modules/studies/getterTypes'
import ActionAlert from '../components/shared/ActionAlert'
import DiagnosticsPopup from '../components/Search/DiagnosticsPopup'
import generalGetters from '../store/modules/general/getterTypes'
import SearchTabs from '../components/Search/SearchTabs'
import searchFunctions from '../helpers/searchFunctions'

export default {
  name: 'Search',
  components: {
    SearchTabs,
    DiagnosticsPopup,
    ActionAlert,
    SearchFilters,
    Breadcrumb,
    SavedSearches
  },
  data () {
    return {
      fields: [],
      activeTab: '',
      ready: true,
      saveMessage: {
        error: false,
        value: ''
      },
      alert: {
        type: '',
        icon: '',
        text: '',
        isVisible: false
      },
      showTabs: false,
      searchIsMetricBased: false,
      currentTabsComponent: 'SearchTabs',
      showDiagnostics: false,
      showSavedSearches: false,
      triggerFadeIn: true,
      filtersVisible: true,
      searchFunctions,
      yearsObject: null,
      dependencies: []
    }
  },
  computed: {
    ...mapGetters({
      filterValues: studiesGetters.GET_SEARCH_FILTERS,
      fragrances: studiesGetters.GET_FRAGRANCES,
      concepts: studiesGetters.GET_CONCEPTS,
      analytics: studiesGetters.GET_ANALYTICS,
      questionnaires: studiesGetters.GET_QUESTIONNAIRES,
      reports: studiesGetters.GET_REPORTS,
      RDF: studiesGetters.GET_RESULTS,
      protocols: studiesGetters.GET_PROTOCOLS,
      saved_searches: studiesGetters.GET_SAVED_SEARCHES,
      screeners: studiesGetters.GET_SCREENERS,
      summaries: studiesGetters.GET_STUDY_SUMMARIES,
      isSidebarToggled: generalGetters.GET_SIDEBAR_STATE
    }),
    savedSearches () {
      return this.saved_searches
    },
    isReady () {
      return !this.ready
    }
  },
  methods: {
    ...mapActions({
      applySearch: studiesActions.APPLY_SEARCH_FILTERS,
      deleteSearch: studiesActions.DELETE_SAVED_SEARCH,
      getFragrances: studiesActions.FETCH_FRAGRANCES,
      getConcepts: studiesActions.FETCH_CONCEPTS,
      getAttributes: studiesActions.CHECK_ATTRIBUTES_JOB_STATUS,
      getPerformance: studiesActions.CHECK_PERFORMANCE_JOB_STATUS,
      getUpdatedDropdownValues: studiesActions.UPDATE_DROPDOWN_OPTIONS,
      getUpdatedMetricsDropdownValues: studiesActions.UPDATE_METRICS_DROPDOWN_OPTIONS,
      getSavedSearches: studiesActions.FETCH_SAVED_SEARCHES,
      getStudies: studiesActions.FETCH_STUDIES,
      getStudiesCount: studiesActions.FETCH_STUDIES_COUNT,
      getStudyFiles: studiesActions.FETCH_FILES,
      getSummaries: studiesActions.FETCH_STUDY_SUMMARIES,
      saveSearch: studiesActions.POST_SAVED_SEARCH,
      toggleLoading: generalActions.TOGGLE_LOADING
    }),
    async updateDropdownValues (values) {
      if (values) {
        const data = this.searchFunctions.parseDataForSearch(values, false)
        const res = await this.getUpdatedDropdownValues({ query: data })
        this.fields = res.data.fields
        this.dependencies = res.data.dependencies
      }
    },
    async searchStudies (parsedData, fullSq, force = false) {
      const tables = Object.keys(this.$refs).filter(el => el.includes('table'))
      tables.forEach(key => {
        this.$refs[key].clearToggledRows()
      })
      switch (this.activeTab) {
        case 'summaries':
          if (force || !this.summaries.length) {
            await this.getSummaries(parsedData)
          }
          break
        case 'fragrances':
          if (force || !this.fragrances.length) {
            await this.getFragrances(parsedData)
          }
          break
        case 'concepts':
          if (force || !this.concepts.length) {
            await this.getConcepts(parsedData)
          }
          break
        case 'questionnaire':
          if (force || !this.questionnaires.length) {
            await this.getStudyFiles({ sq: parsedData, fullSq, fileType: this.activeTab })
          }
          break
        case 'screener':
          if (force || !this.screeners.length) {
            await this.getStudyFiles({ sq: parsedData, fullSq, fileType: this.activeTab })
          }
          break
        case 'protocol':
          if (force || !this.protocols.length) {
            await this.getStudyFiles({ sq: parsedData, fullSq, fileType: this.activeTab })
          }
          break
        case 'RDF_report':
          const fileTypes = this.activeTab.split('_')
          if (force || (!this.RDF.length && !this.reports.length)) {
            await this.getStudyFiles({ sq: parsedData, fullSq, fileType: fileTypes[0] })
            await this.getStudyFiles({ sq: parsedData, fullSq, fileType: fileTypes[1] })
          }
          break
        default:
          if (force || !this.summaries.length) {
            await this.getSummaries(parsedData)
          }
          break
      }
    },
    async searchData (parsedData, additionalData, dataType) {
      this.showTabs = true
      setTimeout(() => window.scrollTo(0, document.body.scrollHeight), 1000)
      this.ready = false
      await this.searchStudies(parsedData, additionalData)
      this.ready = true
    },
    async switchTabs (tab) {
      this.activeTab = tab
      await this.searchData(this.searchFunctions.parseDataForSearch(this.filterValues, false), { file_type: '', search_phrase: '' })
    },
    async refreshData () {
      this.ready = false
      setTimeout(async () => {
        await this.searchStudies(this.searchFunctions.parseDataForSearch(this.filterValues, false), { file_type: '', search_phrase: '' }, true)
        this.ready = true
      }, 1500)
    },
    shouldSaveQuery (data) {
      let saveFlag = false
      Object.keys(data).forEach(category => {
        Object.keys(data[category]).forEach(field => {
          if (data[category][field].value) {
            console.log('IT HIT!')
            saveFlag = true
          }
        })
      })
      return saveFlag
    },
    async resetDropdownValues () {
      const res = await this.getUpdatedDropdownValues(
        {
          query: [{
            field: 'verified',
            value: true,
            target: 'study'
          }]
        })
      this.fields = res.data.fields
      this.dependencies = res.data.dependencies
    },
    async resetComponentState () {
      this.toggleLoading(true)
      this.activeTab = 'summaries'
      if (!this.totalStudiesCount) {
        await this.getStudiesCount()
      }
      await this.getSavedSearches({
        userId: this.$auth.user().id,
        type: 'search'
      })
      await this.resetDropdownValues()
      this.showTabs = false
      this.showDiagnostics = false
      this.toggleLoading(false)
      if (this.$route.params.startSearch) {
        this.$refs.filters.search()
        const scrollElement = document.querySelector('.app-body')
        setTimeout(() => {
          scrollElement.scrollTo(0, scrollElement.scrollHeight)
          this.filtersVisible = false
        }, 50)
      }
    },
    hideTabs () {
      this.showTabs = false
    },
    toggleAlert (type, icon, text) {
      this.alert = {
        type,
        icon,
        text,
        isVisible: true
      }
      setTimeout(() => this.alert.isVisible = false, 3000)
    },
    parseFields () {
      const seekingFields = ['Business Unit', 'Category', 'Client', 'Region', 'Year']
      const collectedFields = {}
      const data = this.fields[0]['data']
      for (let i = 0; i < data.length; ++i) {
        if (seekingFields.includes(data[i].label)) {
          if (data[i].type === 'category') {
            const options = []
            for (let j = 0; j < data[i].options.length; ++j) {
              let { count, value } = data[i].options[j]
              if (data[i].label === 'Year') value = parseInt(value)
              options.push([value, count])
            }

            collectedFields[data[i].label] = options
          }
        }
      }

      const years = [...collectedFields['Year']]
      if (years[0]) {
        const [firstYear, lastYear] = [years[0][0], years[years.length - 1][0]]
        this.yearsObject = {
          min: firstYear,
          max: lastYear,
          marks: { [firstYear]: String(firstYear), [lastYear]: String(lastYear) },
          value: [firstYear, lastYear]
        }
      }
    },
    applyQuery (search) {
      const parsedFilters = JSON.parse(search.metadata_query)
      this.applySearch(parsedFilters)
      this.$refs.filters.refreshFilters(true)
      const yearObject = [
        parsedFilters.essentials.startYear ? parsedFilters.essentials.startYear.value : null,
        parsedFilters.essentials.endYear ? parsedFilters.essentials.endYear.value : null
      ]
      this.$refs.filters.applyYears(yearObject)
    },
    toggleDiagnostics () {
      this.showDiagnostics = !this.showDiagnostics
    },
    toggleSavedSearches () {
      this.$refs.savedSearches.toggle()
      this.showSavedSearches = !this.showSavedSearches
    },
    async saveQuery (name, data) {
      const filters = { ...data }
      delete filters.metrics
      delete filters.demographics
      if (this.shouldSaveQuery(filters)) {
        const parsedData = _.cloneDeep(filters)
        Object.keys(parsedData).forEach(category => {
          Object.keys(parsedData[category]).forEach(key => {
            let fieldData = parsedData[category][key]
            if (typeof fieldData.applyThreshold === 'boolean') {
              return !fieldData.applyThreshold && delete parsedData[category][key]
            } else if (Array.isArray(fieldData)) {
              fieldData.forEach(metric => {
                const applyThreshold = metric.applyThreshold
                Object.keys(metric).forEach(metricKey => {
                  if (metricKey === 'threshold') {
                    return !applyThreshold && delete metric[metricKey]
                  } else {
                    const isArray = Array.isArray(metric[metricKey].value)
                    const isEmpty = isArray ? !!metric[metricKey].value.length : !!metric[metricKey].value
                    return !isEmpty && delete metric[metricKey]
                  }
                })
              })
              parsedData[category][key] = fieldData.filter(value => Object.keys(value).length !== 0)
            } else {
              const isArray = Array.isArray(fieldData.value)
              const isEmpty = isArray ? !!fieldData.value.length : !!fieldData.value
              return !isEmpty && delete parsedData[category][key]
            }
          })
        })
        let data = {
          metadata_query: JSON.stringify(parsedData),
          slug: name || `Search ${this.saved_searches.length + 1}`
        }
        let response = null
        try {
          response = await this.saveSearch({
            userId: this.$auth.user().id,
            data,
            type: 'search'
          })
          if (response.status === 200) {
            this.$refs.savedSearches.toggleBlink()
            this.toggleAlert('success', 'check-circle', `Successfully saved current search as "${data.slug}".`)
            this.saveMessage.error = false
            this.saveMessage.value = ''
            this.$refs.filters.clearName()
            return true
          }
        } catch (e) {
          this.saveMessage.error = true
          this.saveMessage.value = e.response.data.message
          return false
        }
      } else {
        this.saveMessage.error = true
        this.saveMessage.value = 'You can\'t save searches with empty filters!'
        return false
      }
    },
    async removeSavedQuery (searchId) {
      await this.deleteSearch({
        userId: this.$auth.user().id,
        data: { searchId },
        type: 'search'
      })
    }
  },
  async mounted () {
    await this.resetComponentState()
    this.parseFields()
  },
  async beforeRouteLeave (to, from, next) {
    if (this.$refs.filters.areFiltersEmpty || to.name === 'login') {
      await this.$refs.filters.resetFilters()
      next()
    } else if (!to.params.allowLocationChange) {
      this.$refs.filters.togglePopup(to.name)
      next(false)
    } else {
      if (to.name !== 'analytics') {
        await this.$refs.filters.resetFilters()
      }
      next()
    }
  },
  watch: {
    '$route': async function (newPath) {
      this.triggerFadeIn = false
      setTimeout(() => this.triggerFadeIn = true, 0)
      if (['search', 'analytics'].includes(newPath.name)) {
        await this.resetComponentState()
      }
    }
  }
}
</script>

<style>
.nav-link {
  margin-bottom: 0;
}

.el-table::before {
  height: 0 !important;
}

.search-filter {
  width: 100%;
  padding: 10px 20px;
  border-bottom: 1px solid #d1d4d7;
}

.search-filter:last-of-type {
  border-bottom: unset;
}

.tab-pane {
  overflow: scroll;
  position: relative;
}

.saved-searches-header {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.el-checkbox__label {
  color: #20a8d8 !important;
}

.el-checkbox__input.is-checked .el-checkbox__inner {
  border-color: #20a8d8 !important;
  background-color: #20a8d8 !important;
}

.no-overflow {
  overflow: unset !important;
}

.diagnostics {
  position: absolute;
  width: 100%;
  height: 100%;
  right: 0;
  z-index: 1003;
  transition: width 0.2s linear;
}

.sidebard-toggled {
  width: calc(100% - 250px);
}

.footnote {
  margin-top: 5px;
  height: 24px;
}

.footnote-text {
  float: right;
  color: #959799;
  font-size: 16px;
  margin-right: 20px;
}

.description-header {
  color: #959799;
}

.container-fluid {
  padding: 0 !important;
}

.search {
  position: relative;
  z-index: 0;
}

.animated_fade_in {
  position: relative;
  z-index: 0; /*  due to save filters modal*/
}
</style>
